var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMapMarker = function SvgMapMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 24,
    viewBox: "-1 -1 19 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#5D5D5A",
    d: "M16.5 8.5c.003-3.42-2.17-6.464-5.405-7.573C7.86-.183 4.275.887 2.18 3.59c-2.097 2.702-2.244 6.438-.366 9.297l6.308 9.8c.084.13.227.206.38.206.155 0 .298-.077.382-.206L15.55 12.56c.74-1.217 1.074-2.64.95-4.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D5D5A",
    fillRule: "nonzero",
    d: "M.277 7.252h16.45v3H.276zM12.55 17.19H4.584l-1.932-3h12.02M10.674.5H6.362l-4.124 3h12.506"
  }))));
};
export default SvgMapMarker;